/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Tue Apr 04 2023
 **/

import { DependencyList } from "react";
import { useEventHandler } from "@rfice/eventhandler";
import { RestAPIError } from "@/frameworks/libraries/restservice";
import { Configure } from "@/frameworks/libraries/utilities";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOGTAG = "#useAPIState#";

function is_printable() {
	return Configure.useLogLevel > 5;
}

export default function useAPIState<T = unknown>(
	{ name }: { name: string },
	events: API.StateEvents<T>,
	deps: DependencyList = []
) {
	useEventHandler(
		`API-${name}-Okay`,
		(result: any) => {
			events?.onSuccess?.(result);
			is_printable() && console.debug(LOGTAG, `Success ${name}`, result);
		},
		deps
	);

	useEventHandler(
		`API-${name}-Loading`,
		() => {
			events?.onLoading?.();
			is_printable() && console.debug(LOGTAG, `Loading ${name}`);
		},
		deps
	);

	useEventHandler(
		`API-${name}-Error`,
		(apiError: RestAPIError) => {
			events?.onError?.(apiError);
			is_printable() && console.warn(LOGTAG, `Error ${name}`, apiError);
		},
		deps
	);
}
